import { render, staticRenderFns } from "./AddShift.vue?vue&type=template&id=2ef773f0&scoped=true&"
import script from "./AddShift.vue?vue&type=script&lang=js&"
export * from "./AddShift.vue?vue&type=script&lang=js&"
import style0 from "./AddShift.vue?vue&type=style&index=0&id=2ef773f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef773f0",
  null
  
)

export default component.exports